import { ReactElement } from 'react';

import {
   PatientConsentDocumentApprovalResult,
   PatientConsentDocumentApproveCommand,
} from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { printDocumentAsPdf } from '@dreryk/react-common';
import { ModalConfirmButton } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import {
   DocumentTemplateFormBean,
   DocumentTemplateFormController,
   documentTemplateValuesMapToVisitDocumentFieldValue,
} from '~libs.desktop.shared.document-template';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../translations';

import { getConsentTemplateToken } from './ConsentsAndAuthorizationsDocumentTemplateApproveAndPrintButton.utils';

const t = patientConsentsAndAuthorizationsTranslationKeys.consentsAndAuthorizations.documentTemplateModal.actions;

type ConsentsAndAuthorizationsDocumentTemplateApproveAndPrintButtonProps = Pick<
   DocumentTemplateFormController,
   'handleSubmit'
> & {
   readonly printTemplateId: number;
   readonly patientId: number;
   readonly onSuccess: VoidFunction;
};

export const ConsentsAndAuthorizationsDocumentTemplateApproveAndPrintButton = (
   props: ConsentsAndAuthorizationsDocumentTemplateApproveAndPrintButtonProps
): ReactElement => {
   const { executeAsync: approvePatientConsentDocumentTemplate } = useCqrsCommand<
      PatientConsentDocumentApprovalResult,
      DocumentTemplateFormBean
   >(
      (parameters) => {
         const command = new PatientConsentDocumentApproveCommand();
         command.fieldValues = documentTemplateValuesMapToVisitDocumentFieldValue(parameters.documentTemplateValues);
         command.token = Choice.of(getConsentTemplateToken(props.patientId, props.printTemplateId));
         command.patientId = props.patientId;
         command.printTemplateId = props.printTemplateId;
         return command;
      },
      {
         onSuccess: async (result) => {
            props.onSuccess();
            await printDocumentAsPdf({ base64: result.documentFile.data });
         },
      }
   );

   return (
      <ModalConfirmButton
         label={t.approveAndPrint}
         onClick={props.handleSubmit(approvePatientConsentDocumentTemplate)}
      />
   );
};
